const messages = {
    root: {
        pageTitle: 'Czas pracy',
        menuTitle: 'Czas pracy'
    },
    rootV2: {
        pageTitle: 'Czas pracy V2',
        menuTitle: 'Czas pracy V2'
    },
    operatorReporting: {
        routeTitle: 'Czas pracy / Raportowanie',
        createRouteTitle: 'Czas pracy / Raportowanie / Nowy raport',
        menuTitle: 'Raportowanie',
        pageTitle: 'Raportowanie / Zadania',
        greeting: 'Witaj {userName}',
        today: 'Dziś jest {date}',
        currentShift: 'Aktualna zmiana: {shift}',
        fallbackUserName: 'użytkowniku',
        missingShift: 'brak danych',
        unknownMachine: 'nieznanym stanowisku',
        workspaceCard: {
            title: 'Stanowisko',
            empty: '-',
            select: 'Wybierz stanowisko',
            change: 'Zmień stanowisko'
        },
        workspaceDialog: {
            title: 'Ustawienie stanowiska',
            fieldLabel: 'Stanowisko',
            noData: 'Brak stanowisk'
        },
        alerts: {
            missingWorkspace: 'Wybierz stanowisko, aby rozpocząć raportowanie.',
            incompleteWorkspace: 'Konfiguracja na tym stanowisku jest niepełna, zgłoś się do administratora.',
            machineOccupied: 'Maszyna jest obecnie zajęta przez użytkownika {userName}.',
            unfinishedReportDifferentWorkspace: 'Nie zakończyłeś(-aś) raportu na {machineName}.',
            unfinishedReportCurrentWorkspace: 'Masz niezakończony raport na bieżącym stanowisku.'
        },
        actions: {
            startSession: 'Rozpoczynam pracę',
            stopSession: 'Kończę na dziś',
            createAccident: 'Zgłoś awarię',
            accidentsInProgress: 'Awarie w toku',
            reportActivity: 'Raportuj czynność',
            notes: 'Notki',
            callSupervisor: 'Wezwij przełożonego',
            changePriority: 'Zmień Priorytet',
            showMyReports: 'Pokaż moje raporty',
            additionalBoards: 'Zamów płyty dodatkowe'
        },
        supervisorCall: {
            activeLabel: 'Wezwano: {role}',
            activeFallbackLabel: 'Wezwano przełożonego',
            dialog: {
                title: 'Wezwij przełożonego',
                role: 'Kogo wezwać',
                reason: 'Powód wezwania',
                submit: 'Wezwij'
            },
            notifications: {
                created: 'Wezwanie zostało wysłane.'
            },
            service: {
                fetchRolesError: 'Pobranie ról przełożonych nie powiodło się.',
                fetchReasonsError: 'Pobranie powodów wezwania nie powiodło się.',
                fetchActiveCallError: 'Pobranie aktywnego wezwania nie powiodło się.',
                createCallError: 'Wysłanie wezwania nie powiodło się.'
            }
        },
        taskSearch: {
            title: 'Wyszukaj zadanie',
            fieldLabel: 'Numer zadania',
            scanQr: 'Skanuj QR',
            noData: {
                initial: 'Wpisz treść, aby odnaleźć zadanie.',
                minLength: 'Wpisz przynajmniej {count} znaki.',
                loading: 'Trwa wyszukiwanie zadań...',
                notFound: 'Nie odnaleziono zadań na zapytanie: "{query}".'
            }
        },
        shippingGroups: {
            button: 'Sortownie'
        },
        processDialog: {
            title: 'Proces',
            fieldLabel: 'Proces',
            noData: 'Nie znaleziono procesu',
            validation: {
                required: 'Proszę wybrać proces.'
            }
        },
        processReportDialog: {
            title: 'Wybierz czynność',
            start: 'Rozpocznij'
        },
        errorReportingDialog: {
            title: 'Błąd raportowania',
            jobNumber: 'Numer zlecenia',
            impositionNumber: 'Numer montażu',
            validation: {
                jobNumberRequired: 'Numer zlecenia jest wymagany.',
                jobNumberMinLength: 'Numer zlecenia musi mieć co najmniej {count} znaki.'
            }
        },
        outOfSequenceDialog: {
            title: 'Wybierz powód pominięcia.',
            fieldLabel: 'Kod',
            noData: 'Nie znaleziono kodu',
            validation: {
                required: 'Proszę wybrać kod.'
            }
        },
        reportItemOrders: {
            noData: 'Brak zamówień',
            select: 'Wybierz',
            footer: {
                itemsPerPage: 'Zamówień na stronie'
            },
            headers: {
                priority: 'Priorytet',
                delayed: 'Opóźnienie',
                primaryNumber: 'Numer zamówienia',
                amount: 'Nakład',
                productName: 'Produkt',
                plannedSendDate: 'Data wysyłki',
                shippingGroup: 'Sortownia',
                isComplete: 'Kompletność',
                actions: 'Akcje'
            },
            tooltips: {
                priority: 'Priorytet',
                delayed: 'Opóźnione'
            }
        },
        orderJobsDialog: {
            title: 'Zlecenia dla zamówienia: {procNumber}',
            noData: 'Brak danych',
            close: 'Zamknij',
            headers: {
                jobNumber: 'Zlecenie',
                plateNumber: 'Montaż'
            }
        },
        myReportsDialog: {
            productNameTooltip: 'Nazwa produktu: {name}',
            openReportDetails: 'Szczegóły raportu'
        },
        accidentsDialog: {
            title: 'Bieżące awarie na stanowisku',
            qrTitle: 'Awaria {id}',
            qrImageAlt: 'Kod QR awarii'
        },
        notesDialog: {
            title: 'Notki stanowiskowe'
        },
        scheduledTasks: {
            title: 'Zaplanowane zadania',
            noData: 'Brak zadań',
            loading: 'Pobieranie zadań...',
            select: 'Wybierz',
            footer: {
                standardItemsPerPage: 'Zadań na stronie',
                printItemsPerPage: 'Zadań na stronie'
            },
            headers: {
                taskNumber: 'Nr zlecenia',
                orderNumber: 'Nr zamówienia',
                plate: 'Montaż',
                closedFormat: 'Format',
                quantity: 'Nakład',
                volume: 'Objętość',
                foldedSignaturesQuantity: 'Ilość składek',
                coverStatus: 'Status okładki',
                innerStatus: 'Status wnętrz',
                date: 'Zaplanowany start',
                duration: 'Zaplanowany czas',
                status: 'Status',
                process: 'Proces',
                printMethod: 'Sposób druku',
                page: 'Strona',
                paper: 'Rodzaj surowca',
                formatPaper: 'Format surowca',
                grossQuantity: 'Nakład brutto',
                printDuration: 'Czas druku',
                coloursPageA: 'Kolorystyka str. A',
                coloursPageB: 'Kolorystyka str. B',
                varnishSideA: 'Lakier str. A',
                varnishSideB: 'Lakier str. B',
                inserterBatch: 'Liczarka (co ile arkuszy)',
                materialStatus: 'Status materiałów',
                previews: 'Podglądy',
                actions: 'Akcje'
            }
        },
        interruptedReports: {
            noData: 'Brak danych',
            loading: 'Pobieranie raportów...',
            footer: {
                itemsPerPage: 'Wierszy na stronie:'
            },
            headers: {
                number: 'Numer',
                machine: 'Maszyna',
                process: 'Proces',
                plate: 'Montaż',
                reportAmount: 'Nakład wykonany',
                machineStuffAmount: 'Ilość osób',
                status: 'Status',
                start: 'Data rozpoczęcia',
                actions: 'Akcje'
            }
        },
        summary: {
            reportedTime: 'Zaraportowany czas:'
        },
        tooltips: {
            orderJobsPreview: 'Podgląd numerów zleceń',
            openPreviews: 'Otwórz podglądy',
            noPreviews: 'Brak podglądów',
            materialStatusDetails: 'MAGAZYN: {warehouseStatus}\nCTP: {ctpStatus}\nGUMA: {rubberStatus}'
        },
        stopSessionDialog: {
            title: 'Zakończenie dziennego raportu',
            content: 'Czy na pewno chcesz zakończyć pracę?',
            confirm: 'Zakończ'
        },
        notifications: {
            cannotStartOnWorkspace: 'Nie można rozpocząć raportowania na wybranym stanowisku.',
            workspaceDoesNotSupportJobs: 'Wybrane stanowisko nie obsługuje zleceń.',
            workspaceDoesNotSupportOrders: 'Wybrane stanowisko nie obsługuje zamówień.',
            sessionStarted: 'Rozpoczęto sesję.',
            sessionStopped: 'Zakończono pracę.',
            taskPrepared: 'Przygotowano zadanie do kolejnego etapu raportowania.',
            taskUnavailable: 'Wybrane zadanie nie jest możliwe do zaraportowania.',
            processUnavailable: 'Brak procesu dla wybranego zadania.',
            scheduledTaskProcessMissing: 'Dodany proces dla zadania z planu nie istnieje w bazie.',
            additionalBoardsTaskDataUnavailable: 'Nie znaleziono danych zlecenia do zamówienia płyt.',
            unsupportedQrTaskType: 'Zeskanowany kod QR zawiera nieobsługiwany typ zadania.',
            qrSelectionBlocked: 'W bieżącym stanie nie można wybrać zadania przez skaner.',
            qrSessionRequired: 'Nie rozpoczęto pracy.',
            qrWorkspaceRequired: 'Nie ustawiono stanowiska.',
            qrWorkspaceUnavailable: 'Nie można raportować na wybranym stanowisku.'
        },
        service: {
            fetchWorkspacesError: 'Pobranie stanowisk do raportowania nie powiodło się.',
            fetchWorkspaceError: 'Pobranie danych stanowiska nie powiodło się.',
            fetchSessionError: 'Pobranie aktywnej sesji raportowania nie powiodło się.',
            fetchInterruptedReportsError: 'Pobranie niezakończonych raportów nie powiodło się.',
            fetchReportStatusesError: 'Pobranie statusów raportów nie powiodło się.',
            fetchReportProcessesError: 'Pobranie procesów do zaraportowania nie powiodło się.',
            fetchOutOfSequenceCodesError: 'Pobranie kodów pominięcia kolejności nie powiodło się.',
            fetchScheduledTasksError: 'Pobranie zaplanowanych zadań nie powiodło się.',
            fetchReportingParametersError: 'Pobranie konfiguracji parametrów stanowiska nie powiodło się.',
            fetchShippingGroupsError: 'Pobranie danych o sortowniach nie powiodło się.',
            fetchReportItemOrdersError: 'Pobranie danych zamówień nie powiodło się.',
            findTasksError: 'Wyszukiwanie zadań nie powiodło się.',
            findTaskByNumberError: 'Pobranie wybranego zadania nie powiodło się.',
            fetchOrderJobsError: 'Pobranie danych o zleceniach nie powiodło się.',
            startSessionError: 'Rozpoczęcie sesji nie powiodło się.',
            stopSessionError: 'Zakończenie sesji nie powiodło się.',
            fetchStoppedSessionDetailsError: 'Pobranie podsumowania sesji nie powiodło się.'
        }
    },
    paperReporting: {
        routeTitle: 'Czas pracy / Raportowanie papieru',
        menuTitle: 'Raportowanie papieru',
        pageTitle: 'Raportowanie / Raportowanie papieru',
        greeting: 'Witaj {userName}',
        today: 'Dziś jest {date}',
        currentShift: 'Aktualna zmiana: {shift}',
        fallbackUserName: 'użytkowniku',
        missingShift: 'brak danych',
        actions: {
            refresh: 'Odśwież'
        },
        activeReports: {
            noData: 'Brak danych',
            loading: 'Pobieranie raportów...',
            footer: {
                itemsPerPage: 'Wierszy na stronie:'
            },
            actions: {
                select: 'Wybierz'
            },
            tooltips: {
                openDetails: 'Szczegóły raportu'
            },
            headers: {
                number: 'Numer',
                machine: 'Maszyna',
                process: 'Proces',
                plate: 'Montaż',
                reportAmount: 'Nakład wykonany',
                machineStuffAmount: 'Ilość osób',
                status: 'Status',
                start: 'Data rozpoczęcia',
                actions: 'Akcje'
            }
        },
        detail: {
            routeTitle: 'Czas pracy / Raportowanie papieru / Szczegóły raportu',
            pageTitle: 'Raportowanie / Szczegóły raportu',
            actions: {
                backToList: 'Powrót do listy'
            },
            timer: {
                makeReadyStart: 'Rozpoczęcie przyrządu:',
                makeReadyFinish: 'Zakończenie przyrządu:',
                makeReadyDuration: 'Czas przyrządu:',
                printStart: 'Rozpoczęcie jazdy:',
                printFinish: 'Zakończenie jazdy:',
                start: 'Rozpoczęcie:',
                finish: 'Zakończenie:',
                duration: 'Czas:',
                printDuration: 'Czas jazdy:',
                delay: 'Opóźnienie:'
            },
            parameters: {
                title: 'Parametry',
                orderNumber: 'Nr zamówienia:',
                product: 'Produkt:',
                amount: 'Nakład:',
                machine: 'Maszyna:',
                process: 'Proces:',
                leftAmount: 'Pozostały nakład:',
                reportAmount: 'Wykonany nakład:',
                people: 'Ilość osób:',
                signature: 'Składka',
                plate: 'Montaż',
                foldedSignatureDescription: 'opis: {description},',
                foldedSignaturePages: 'ilość stron: {pages},',
                foldedSignatureQuantity: 'ilość: {quantity}'
            },
            pallets: {
                title: 'Palety',
                noData: 'Brak danych',
                headers: {
                    number: 'Numer palety',
                    actions: 'Akcje'
                },
                fields: {
                    number: 'Numer palety',
                    hint: 'Wpisz lub zeskanuj numer palety'
                },
                actions: {
                    add: 'Dodaj',
                    remove: 'Usuń'
                },
                errors: {
                    required: 'Kod palety jest wymagany.',
                    invalid: 'Podany kod jest nieprawidłowy',
                    missingId: 'Brak identyfikatora palety. Nie można usunąć palety.'
                },
                notifications: {
                    duplicate: 'Wprowadzony numer został już wcześniej dodany.',
                    notFound: 'Paleta o podanym numerze nie istnieje.',
                    added: 'Dodano paletę z papierem do raportu.',
                    removed: 'Paleta z papierem została usunięta z raportu.'
                }
            },
            paperTransfer: {
                title: 'Przeniesienie cech papieru',
                content: 'Wykryto ten sam papier jak w poprzednim zleceniu. Czy chcesz przenieść cechy papieru?',
                confirm: 'Tak',
                abort: 'Nie'
            },
            notifications: {
                invalidReportId: 'Nieprawidłowy identyfikator raportu.'
            }
        },
        scheduledTasks: {
            noData: 'Brak Zamówień',
            loading: 'Pobieranie zadań...',
            footer: {
                itemsPerPage: 'Zamówień na stronie'
            },
            headers: {
                taskNumber: 'Nr zlecenia',
                plate: 'Montaż',
                printMethod: 'Sposób druku',
                page: 'Strona',
                paper: 'Rodzaj surowca',
                formatPaper: 'Format surowca',
                grossQuantity: 'Nakład brutto',
                date: 'Zaplanowany start',
                printDuration: 'Czas druku',
                coloursPageA: 'Kolorystyka str. A',
                coloursPageB: 'Kolorystyka str. B',
                varnishSideA: 'Lakier str. A',
                varnishSideB: 'Lakier str. B',
                inserterBatch: 'Liczarka (co ile arkuszy)',
                materialStatus: 'Status materiałów'
            }
        },
        tooltips: {
            materialStatusDetails: 'MAGAZYN: {warehouseStatus}\nCTP: {ctpStatus}\nGUMA: {rubberStatus}'
        },
        service: {
            fetchWorkspacesError: 'Pobranie stanowisk do raportowania papieru nie powiodło się.',
            fetchWorkspaceError: 'Pobranie danych stanowiska nie powiodło się.',
            fetchActiveReportsError: 'Pobranie aktywnych raportów nie powiodło się.',
            fetchScheduledTasksError: 'Pobranie zaplanowanych zadań do zaraportowania papieru nie powiodło się.',
            fetchReportingParametersError: 'Pobranie konfiguracji parametrów stanowiska nie powiodło się.',
            fetchPaperReportError: 'Pobranie danych raportu nie powiodło się.',
            fetchTaskNamesError: 'Pobranie nazw zadań nie powiodło się.',
            checkPalletParameterError: 'Sprawdzenie numeru palety nie powiodło się.',
            addPalletError: 'Dodanie palety z papierem nie powiodło się.',
            removePalletError: 'Usunięcie palety z papierem nie powiodło się.'
        }
    },
    managerApprovals: {
        routeTitle: 'Czas pracy / Zatwierdzenia',
        menuTitle: 'Zatwierdzenia',
        pageTitle: 'Zatwierdzania Raportów',
        backToList: 'Powrót do listy',
        filters: {
            department: 'Dział',
            siteGroups: 'Grupa stanowisk',
            site: 'Stanowisko',
            search: 'Szukaj...',
            user: 'Użytkownik',
            supervisor: 'Przełożony',
            date: 'Data',
            status: 'Status',
            noUsers: 'Nie znaleziono',
            noDepartments: 'Nie znaleziono działu',
            noSiteGroups: 'Nie znaleziono grupy stanowisk',
            noSites: 'Nie znaleziono stanowiska',
            noStatuses: 'Nie znaleziono statusu',
            userPrompt: 'Wpisz treść aby odnaleźć użytkownika.',
            supervisorPrompt: 'Wpisz treść aby odnaleźć przełożonego.',
            userSearching: 'Trwa wyszukiwanie...'
        },
        actions: {
            approve: 'Zatwierdź',
            generateReport: 'Generuj raport',
            generateDetailedReport: 'Generuj raport szczegółowy'
        },
        additionalActivityDialog: {
            title: 'Zatwierdzanie czynności dodatkowej',
            processLabel: 'Nazwa czynności',
            commentLabel: 'Komentarz',
            reject: 'Odrzuć',
            cancel: 'Anuluj',
            save: 'Zapisz',
            errors: {
                commentApproveLength: 'Proszę podać komentarz o długości od 3 do 128 znaków, lub zostawić pustym.',
                commentRejectLength: 'Proszę podać komentarz o długości od 3 do 128 znaków.'
            }
        },
        table: {
            user: 'Pracownik',
            machine: 'Maszyna',
            start: 'Start',
            stop: 'Stop',
            reportedAmount: 'Nakład',
            finishedReports: 'Suma zadań',
            process: 'Process',
            efficiency: 'Sprawność',
            reportedTime: 'Zaraportowano',
            approvalDate: 'Data zatwierdzenia',
            approvedBy: 'Zatwierdzający',
            status: 'Status',
            actions: 'Akcje'
        },
        detailed: {
            routeTitle: 'Czas pracy / Zatwierdzanie raportów / Raporty szczegółowe',
            pageTitle: 'Zatwierdzanie raportów / Raporty szczegółowe',
            filters: {
                search: 'Szukaj...'
            },
            summary: {
                user: 'Pracownik:',
                totalAmount: 'Łączny nakład:',
                totalTasks: 'Suma zadań:',
                finishedOrders: 'Ilość zaraportowanych zamówień:',
                averagePeople: 'Średnia ilość osób:',
                planResult: 'Końcowy wynik wykonania planu:',
                start: 'Start:',
                stop: 'Stop:',
                reported: 'Zaraportowano:',
                chartLabel: 'Zadania'
            },
            table: {
                objectNumber: 'Numer',
                machine: 'Maszyna',
                process: 'Proces',
                plateNumber: 'Montaż',
                reportAmount: 'Nakład wykonany',
                people: 'Ilość osób',
                status: 'Status',
                start: 'Data rozpoczęcia',
                finish: 'Data zakończenia',
                duration: 'Czas trwania',
                userWorkEfficiency: 'W normie',
                actions: 'Akcje'
            }
        },
        tooltips: {
            approveAdditionalActivity: 'Zatwierdzanie czynności dodatkowej',
            openShiftSummaryDetails: 'Szczegóły raportu'
        },
        notifications: {
            reportApproved: 'Raport został zatwierdzony.',
            reportSent: 'Raport został wysłany na adres {userEmail}.',
            additionalActivitySaved: 'Zapisano decyzję dotyczącą czynności dodatkowej.'
        }
    },
    myReports: {
        routeTitle: 'Czas pracy / Moje raporty',
        menuTitle: 'Moje raporty',
        pageTitle: 'Moje raporty',
        backToList: 'Powrót do listy',
        filters: {
            group: 'Grupa',
            date: 'Data',
            noGroups: 'Nie znaleziono grupy'
        },
        groups: {
            bindery: 'Introligatornia'
        },
        table: {
            start: 'Start',
            stop: 'Stop',
            reportedAmount: 'Nakład',
            finishedReports: 'Suma zadań',
            efficiency: 'Sprawność',
            duration: 'Zaraportowano',
            status: 'Status',
            actions: 'Akcje'
        },
        detailed: {
            routeTitle: 'Czas pracy / Moje raporty / Raporty szczegółowe',
            pageTitle: 'Moje raporty / Raporty szczegółowe',
            search: 'Szukaj...',
            productNameTooltip: 'Nazwa produktu: {name}',
            table: {
                objectNumber: 'Numer',
                userName: 'Użytkownik',
                machine: 'Maszyna',
                process: 'Proces',
                plateNumber: 'Montaż',
                reportAmount: 'Nakład wykonany',
                people: 'Ilość osób',
                status: 'Status',
                start: 'Data rozpoczęcia',
                finish: 'Data zakończenia',
                duration: 'Czas trwania',
                actions: 'Akcje'
            }
        }
    },
    reportExecution: {
        create: {
            pageTitle: 'Nowy raport - {process} na {machine}',
            actions: {
                backToList: 'Powrót do listy',
                close: 'Zamknij'
            },
            comments: {
                show: 'Pokaż uwagi do zadania',
                title: 'Uwagi do zadania',
                confirm: 'Potwierdzam zapoznanie się z komentarzem'
            },
            complaintOrders: {
                title: 'Zamówienia',
                noData: 'Brak danych',
                singleAlert: 'Zamówienie reklamowane',
                multipleAlert: 'Zawiera zamówienia reklamowane (ZOBACZ)',
                headers: {
                    orderNumber: 'Numer zamówienia',
                    productName: 'Produkt'
                }
            },
            materialReservation: {
                action: 'Zgłoś zapotrzebowanie materiału',
                dialog: {
                    title: 'Zgłoś zapotrzebowanie materiału',
                    headers: {
                        materialType: 'Typ materiału',
                        material: 'Materiał',
                        amount: 'Ilość',
                        unit: 'JM',
                        actions: 'Akcje'
                    },
                    fields: {
                        materialType: 'Typ materiału',
                        material: 'Materiał',
                        amount: 'Ilość'
                    },
                    actions: {
                        addMaterial: 'Dodaj kolejny materiał',
                        cancel: 'Anuluj',
                        submit: 'Wyślij'
                    }
                },
                notifications: {
                    sent: 'Zapotrzebowanie materiału zostało wysłane.'
                }
            },
            pallets: {
                action: 'Papier',
                dialog: {
                    title: 'Palety',
                    noData: 'Brak danych',
                    headers: {
                        number: 'Numer palety',
                        actions: 'Akcje'
                    },
                    fields: {
                        number: 'Numer palety',
                        hint: 'Wpisz lub zeskanuj numer palety'
                    },
                    actions: {
                        add: 'Dodaj',
                        remove: 'Usuń',
                        refresh: 'Odśwież'
                    },
                    errors: {
                        required: 'Kod palety jest wymagany.',
                        invalid: 'Podany kod jest nieprawidłowy.'
                    }
                },
                lastPalletDialog: {
                    title: 'Paleta z surowcem',
                    content:
                        'Znaleziono ostatnio zaraportowaną paletę z papierem: {parameter}. Czy chcesz kontynuować ze wskazanym surowcem?',
                    confirm: 'Kontynuuj'
                },
                notifications: {
                    duplicate: 'Wprowadzony numer został już wcześniej dodany.',
                    notFound: 'Paleta o podanym numerze nie istnieje.',
                    added: 'Dodano paletę z papierem do raportu.',
                    removed: 'Paleta z papierem została usunięta z raportu.'
                }
            },
            start: {
                standard: 'Rozpocznij',
                makeReady: 'Rozpocznij przyrząd',
                qrAlt: 'Kod QR rozpoczęcia raportu'
            },
            parameters: {
                title: 'Parametry {type}',
                productJobTitle: 'Parametry produktu ze zlecenia',
                number: 'Numer:',
                product: 'Produkt:',
                amount: 'Nakład:',
                pieces: '{amount} szt.',
                localization: 'Lokalizacja:',
                plate: 'Montaż',
                productSelection: 'Produkt',
                signature: 'Składka',
                foldedSignature: 'Opis: {description}, ilość stron {pages}, ilość: {quantity}',
                storagePlace: 'hala: {hall}, rząd {ordinalNumber}, palet: {count}'
            },
            additionalActions: {
                headers: {
                    name: 'Wykonane czynności'
                }
            },
            preview: {
                title: 'Podgląd',
                empty: 'Brak podglądów.',
                imageAlt: 'Podgląd zadania',
                page: 'Strona {page}',
                defaultGroup: 'Podgląd'
            },
            mockups: {
                title: 'Makieta',
                empty: 'Brak podglądów makiet.',
                imageAlt: 'Makieta'
            },
            tooltips: {
                commentsRequired: 'Potwierdź zapoznanie się z uwagami do zadania.',
                palletsRequired: 'Dodaj co najmniej jedną paletę papieru przed rozpoczęciem raportu.',
                missingPayload: 'Nie udało się przygotować danych raportu dla wybranego zadania.'
            },
            notifications: {
                missingContext: 'Brak danych zadania do utworzenia raportu.',
                taskFullyReported: 'Wybrane zadanie jest już w pełni zaraportowane.'
            }
        },
        nextProcessPalletSuggestions: {
            title: 'Podpowiedzi palet do kolejnego procesu',
            service: {
                fetchError: 'Nie udało się pobrać podpowiedzi palet.'
            },
            table: {
                noData: 'Brak konfiguracji',
                loading: 'Ładowanie...',
                headers: {
                    process: 'Sugerowany kolejny proces produkcyjny',
                    pallet: 'Paleta'
                }
            }
        },
        detail: {
            routeTitle: 'Raportowanie / Szczegóły raportu',
            pageTitle: 'Raport {number}',
            actions: {
                back: 'Wstecz',
                accidentsInProgress: 'Awarie w toku',
                materialReservation: 'Zgłoś zapotrzebowanie materiału',
                pallets: 'Papier',
                finishProcessReport: 'Zakończ',
                finishMakeReady: 'Zakończ przyrząd',
                breakMakeReady: 'Przerwij przyrząd',
                finishReport: 'Zakończ raport',
                breakReport: 'Przerwij raport',
                renewMakeReady: 'Wznów przyrząd',
                renewReport: 'Wznów raport',
                additionalBoards: 'Zamów płyty dodatkowe',
                stopBlackBoxCounting: 'Zatrzymaj liczenie',
                resumeBlackBoxCounting: 'Wznów liczenie'
            },
            badges: {
                printMode: 'Tryb druku: {mode}',
                printModeUnknown: 'Nieokreślony'
            },
            alerts: {
                plateSetReplacement: 'Wymiana kompletu płyt co {sheets} arkuszy!'
            },
            header: {
                productionTitle: 'Zlecenie produkcyjne {number}{plate}',
                processReportTitle: 'Czynność {process}',
                otherTaskReportTitle: 'Inne zadanie - {process}',
                plate: 'Montaż {plate}',
                foldedSignature: 'Składka {plate}'
            },
            timeline: {
                makeReadyStart: 'Rozpoczęcie przyrządu:',
                makeReadyFinish: 'Zakończenie przyrządu:',
                makeReadyDuration: 'Czas przyrządu:',
                start: 'Rozpoczęcie:',
                finish: 'Zakończenie:',
                duration: 'Czas:',
                productionStart: 'Rozpoczęcie jazdy:',
                productionFinish: 'Zakończenie jazdy:',
                productionDuration: 'Czas jazdy:',
                delay: 'Opóźnienie:',
                leftAmount: 'Pozostały nakład:'
            },
            blackBox: {
                readError: 'Błąd odczytu'
            },
            sections: {
                parameters: 'Parametry',
                runtime: 'Raportowanie',
                preview: 'Podgląd',
                mockups: 'Makieta',
                nextTasks: 'Kolejne zadania',
                comments: 'Lista zdarzeń'
            },
            parameters: {
                objectNumber: 'Nr zamówienia:',
                product: 'Produkt:',
                amount: 'Nakład:',
                machine: 'Maszyna:',
                process: 'Proces:',
                leftAmount: 'Pozostały nakład:',
                reportAmount: 'Wykonany nakład:',
                people: 'Ilość osób:',
                foldedSignature: 'Opis: {description}, ilość stron: {pages}, ilość: {quantity}'
            },
            runtime: {
                titleWithSide: 'Raport strona: {side}',
                titleWithPlate: 'Raportowanie montażu {plate}',
                people: 'Ilość osób',
                remainingAmount: 'Pozostały nakład:',
                status: 'Status:',
                errors: {
                    peopleRequired: 'Proszę podać ilość osób.'
                },
                stopQrAlt: 'Kod QR zakończenia raportu',
                steps: {
                    report: 'Raport',
                    orders: 'Zamówienia',
                    packaging: 'Pakowanie'
                }
            },
            packaging: {
                title: 'Pakowanie',
                noPackaging: 'Brak pakowania.',
                errors: {
                    missingPackageType: 'Adres nie ma typu opakowania — nie można nadać pojedynczego listu.'
                },
                addressCounter: 'Adres {current} z {total}',
                steps: {
                    report: 'Raport',
                    orders: 'Zamówienia',
                    packaging: 'Pakowanie'
                },
                fields: {
                    status: 'Status:',
                    packageAmount: 'Ilość kartonów:',
                    amountToShip: 'Nakład:',
                    weight: 'Waga:',
                    courier: 'Kurier:'
                },
                units: {
                    pieces: 'szt.'
                },
                boxes: {
                    packageType: 'Typ kartonu',
                    amount: 'Ilość',
                    collectingType: 'Typ zbiorczego',
                    collectingAmount: 'Ilość',
                    sum: 'Suma:',
                    shopDataBadge: 'Dane pobrane ze sklepu'
                },
                actions: {
                    send: 'Nadaj',
                    print: 'Wydrukuj',
                    reprint: 'Wydrukuj ponownie',
                    finishSending: 'Zakończ nadawanie',
                    generateNew: 'Generuj nowe',
                    printLieferschein: 'Wydrukuj Lieferschein',
                    recalculate: 'Przelicz',
                    showOrderComments: 'Pokaż uwagi do zamówienia',
                    confirmOrderComments: 'Potwierdzam zapoznanie się z komentarzem'
                },
                alerts: {
                    shippingBlocked: 'Wysyłka zablokowana. Zostanie wygenerowana etykieta tymczasowa.',
                    cashOnDeliveryPartialSent: 'Zamówienie nadane za pobraniem. Jeżeli chcesz nadać, zrób to ręcznie.',
                    standardCooperantOrder: 'To jest zamówienie wykonywane w kooperacji. Nadanie na linii nie jest możliwe.',
                    multiProjectCashOnDelivery: 'Zamówienie wielowzorowe za pobraniem. Nie można nadać na linii.',
                    palletShipment: 'Przesyłka wysyłana paletą.',
                    inpostCarrierLocked:
                        'Przesyłka InPost ze sklepu. Kurier jest przypisany zgodnie z danymi ze sklepu i nie może zostać zmieniony.',
                    inpostCarrierLockedDetails: 'Paczkomat: {lockerCode}, gabaryt: {shipmentSize}.',
                    containerCarrierLocked:
                        'Nadano już listy przewozowe dla tego adresu. Kuriera można zmienić po zakończeniu nadawania.',
                    singleLabelLimitReached: 'Osiągnięto maksymalną liczbę etykiet dla tego zamówienia'
                },
                orderComments: {
                    title: 'Uwagi do zamówienia'
                },
                orders: {
                    title: 'Zamówienia',
                    previewAlt: 'Podgląd zamówienia',
                    noPreview: 'Brak podglądu',
                    send: 'Nadaj',
                    sent: 'Nadane',
                    headers: {
                        preview: 'Podgląd',
                        orderNumber: 'Numer zamówienia',
                        productName: 'Produkt',
                        amount: 'Nakład',
                        template: 'Wzór',
                        type: 'Rodzaj'
                    }
                },
                pinDialog: {
                    title: 'Wprowadź PIN',
                    fields: {
                        pin: 'PIN'
                    }
                },
                packageAmountDialog: {
                    title: 'Zmiana ilości kartonów',
                    fields: {
                        packageAmount: 'Ilość kartonów'
                    },
                    errors: {
                        range: 'Proszę podać wartość z zakresu {min}-{max}'
                    }
                },
                amountToShipDialog: {
                    title: 'Zmiana nakładu do nadania',
                    fields: {
                        amount: 'Nakład'
                    },
                    errors: {
                        invalid: 'Proszę podać prawidłową wartość'
                    }
                },
                courierDialog: {
                    title: 'Zmiana parametrów wysyłki',
                    noData: 'Nie znaleziono przewoźnika',
                    fields: {
                        courier: 'Przewoźnik'
                    }
                },
                reprintDialog: {
                    title: 'Wybierz etykiety do ponownego wydruku',
                    headers: {
                        carrier: 'Kurier',
                        createdAt: 'Data utworzenia',
                        shippedAmount: 'Nadany nakład',
                        numberOfLabels: 'Ilość etykiet'
                    }
                },
                tooltips: {
                    actionInProgress: 'Trwa obsługa akcji raportu. Spróbuj ponownie za chwilę.',
                    sendingDisabled: 'Stanowisko nie pozwala na nadawanie zamówień.',
                    unavailable: 'Nadanie jest dostępne tylko z aktywnego raportu na tym samym stanowisku.'
                },
                notifications: {
                    printed: 'Etykieta została wydrukowana.',
                    sendingFinished: 'Zakończono nadawanie.',
                    temporaryLabelsSaved: 'Poprawnie zapisano etykiety tymczasowe dla zamówienia.',
                    lieferscheinPrinted: 'Lieferschein został wydrukowany.',
                    multiProject: 'Zamówienie wielowzorowe. Nie można nadać na linii.',
                    multiProjectCashOnDelivery: 'Zamówienie wielowzorowe za pobraniem. Nie można nadać na linii.',
                    minBoxesReached: 'Osiągnięto minimalną ilość kartonów.',
                    maxBoxesReached: 'Osiągnięto maksymalną ilość kartonów.'
                }
            },
            amountDialog: {
                reportTitle: 'Wykonany nakład',
                makeReadyTitle: 'Nakład na przyrząd',
                productionTitle: 'Nakład z jazdy',
                fields: {
                    amount: 'Nakład'
                },
                errors: {
                    required: 'Proszę podać nakład.',
                    integer: 'Nakład musi być liczbą całkowitą.',
                    min: 'Nakład nie może być mniejszy niż 0.',
                    max: 'Nakład nie może przekraczać pozostałego nakładu.'
                }
            },
            breakCommentDialog: {
                title: 'Proszę wybrać powód przerwy.',
                noData: 'Nie znaleziono komentarzy',
                fields: {
                    comment: 'Komentarz'
                },
                errors: {
                    required: 'Proszę wybrać przyczynę.'
                }
            },
            finishCommentDialog: {
                title: 'Proszę wybrać powód.',
                delayTitle: 'Spóźnienia',
                amountTitle: 'Zaraportowania niepełnego nakładu',
                errors: {
                    delayRequired: 'Proszę wybrać powód spóźnienia.',
                    amountRequired: 'Proszę wybrać powód zaraportowania niepełnego nakładu.'
                }
            },
            confirmBreakFullAmount: {
                title: 'Wprowadzono pełny nakład.',
                content: 'Czy na pewno chcesz przerwać raportowanie?'
            },
            continuation: {
                offsetNextPlate: {
                    title: 'Czy chcesz przejść do kolejnego zadania w planie:',
                    content: '{task}, montaż: {plate}'
                },
                nextUnreportedPlate: {
                    title: 'Znaleziono niezaraportowany montaż dla tego zlecenia.',
                    content: 'Czy chcesz zaraportować kolejny montaż?'
                },
                nextUnreportedProduct: {
                    title: 'Znaleziono niezaraportowany produkt dla tego zlecenia.',
                    content: 'Czy chcesz zaraportować kolejny produkt: {productName}?'
                },
                nextScheduledTask: {
                    title: 'Wybierz kolejny krok',
                    content: 'Czy chcesz przejść do kolejnego zadania w planie: {task}, montaż {plate}?'
                }
            },
            additionalBoards: {
                title: 'Domawianie płyt',
                noReasons: 'Brak powodów',
                noColours: 'Brak konfiguracji kolorystyki',
                fields: {
                    reason: 'Przyczyna'
                },
                actions: {
                    order: 'Zamów'
                },
                notifications: {
                    created: 'Zamówienie płyt dodatkowych zostało utworzone.'
                },
                history: {
                    headers: {
                        createdAt: 'Data',
                        reasons: 'Powód',
                        sideA: 'Zakres strona A',
                        sideB: 'Zakres strona B',
                        status: 'Wykonano'
                    }
                }
            },
            additionalActions: {
                headers: {
                    name: 'Wykonane czynności'
                }
            },
            preview: {
                pages: 'Strony',
                page: 'Strona {page}',
                defaultGroup: 'Podgląd',
                empty: 'Brak podglądów.',
                imageAlt: 'Podgląd raportu',
                mockupEmpty: 'Brak podglądów makiet.',
                mockupImageAlt: 'Makieta raportu'
            },
            comments: {
                noData: 'Brak zdarzeń.',
                headers: {
                    codeType: 'Zdarzenie',
                    description: 'Opis',
                    createdDateTime: 'Data utworzenia'
                }
            },
            controlCode: {
                title: 'Kontrola kodu',
                noData: 'Brak zeskanowanych kodów',
                headers: {
                    code: 'Kod',
                    compliant: 'Zgodność kodu',
                    nonCompliant: 'Niezgodność kodu'
                },
                actions: {
                    start: 'Start'
                },
                dialog: {
                    title: 'Skanowanie kodów EAN',
                    scannedPattern: 'Zeskanowany wzór - {pattern}',
                    scanProductCode: 'Zeskanuj kod produktu',
                    scanPatternCode: 'Zeskanuj kod wzoru',
                    isCompliant: 'Czy kod jest zgodny',
                    actions: {
                        nextPattern: 'Kolejny wzór',
                        finish: 'Zakończ'
                    }
                }
            },
            reportAmountDialog: {
                title: 'Edycja zaraportowanego nakładu',
                fieldLabel: 'Zaraportowany nakład'
            },
            nextTasks: {
                noData: 'Brak kolejnego zadania do pokazania.',
                headers: {
                    number: 'Numer',
                    technologyNumber: 'Nr technologiczny',
                    plate: 'Montaż',
                    preview: 'Podgląd'
                }
            },
            tooltips: {
                additionalBoardsMissingContext: 'Brak danych raportu wymaganych do zamówienia płyt dodatkowych.',
                reportAmountEdit: 'Edytuj zaraportowany nakład'
            },
            notifications: {
                invalidReportId: 'Nieprawidłowy identyfikator raportu.',
                reportAmountUpdated: 'Zaktualizowano zaraportowany nakład.',
                continuationTaskUnavailable: 'Nie udało się odnaleźć kolejnego zadania do raportowania.'
            }
        },
        service: {
            fetchReportError: 'Pobranie szczegółów raportu nie powiodło się.',
            fetchProductionSiteError: 'Pobranie danych stanowiska raportu nie powiodło się.',
            fetchTaskError: 'Pobranie danych zadania nie powiodło się.',
            fetchAdditionalActionsError: 'Pobranie dodatkowych czynności nie powiodło się.',
            createReportError: 'Rejestrowanie czasu nie powiodło się.',
            fetchCodeCompliancesError: 'Pobranie wzorów zgodności kodów nie powiodło się.',
            createCodeComplianceError: 'Dodanie wzoru zgodności kodu nie powiodło się.',
            addCodeCompliancePatternError: 'Dodanie kodu zgodności nie powiodło się.',
            finishReportError: 'Zakończenie raportu nie powiodło się.',
            breakReportError: 'Przerwanie raportu nie powiodło się.',
            renewReportError: 'Wznowienie raportu nie powiodło się.',
            endMakeReadyError: 'Zakończenie raportowania przyrządu nie powiodło się.',
            updateReportAmountError: 'Aktualizacja zaraportowanego nakładu nie powiodła się.',
            updateReportItemPlateError: 'Aktualizacja płyty zadania nie powiodła się.',
            fetchCommentCodesError: 'Pobranie kodów komentarzy nie powiodło się.',
            fetchNextPlatesError: 'Pobranie kolejnych montaży do raportowania nie powiodło się.',
            fetchNextPlateError: 'Pobranie kolejnej płyty do raportowania nie powiodło się.',
            fetchReportItemColoursError: 'Pobranie kolorystyki zlecenia nie powiodło się.',
            fetchPlateOrderReasonsError: 'Pobranie powodów domówienia płyt nie powiodło się.',
            createPlateOrderError: 'Zamówienie płyt dodatkowych nie powiodło się.',
            fetchMachinePlateItemsError: 'Pobranie wykonania płyt dodatkowych nie powiodło się.',
            fetchPlateOrderHistoryError: 'Pobranie historii domówień płyt nie powiodło się.',
            checkPalletParameterError: 'Sprawdzenie numeru palety nie powiodło się.',
            addPalletError: 'Dodanie palety z papierem nie powiodło się.',
            removePalletError: 'Usunięcie palety z papierem nie powiodło się.',
            fetchMaterialTypesError: 'Pobranie typów materiałów nie powiodło się.',
            fetchMaterialsError: 'Pobranie listy materiałów nie powiodło się.',
            createMaterialReservationError: 'Wysłanie zapotrzebowania materiału nie powiodło się.',
            fetchBlackBoxAmountError: 'Pobranie informacji z czarnej skrzynki nie powiodło się.',
            setBlackBoxLightError: 'Ustawienie światła w czarnej skrzynce nie powiodło się.',
            pauseResumeBlackBoxCountingError: 'Zmiana stanu liczenia czarnej skrzynki nie powiodła się.',
            prinectAmountSuccess: 'Pobrano nakład z systemu Prinect.',
            prinectMakeReadyAmountSuccess: 'Pobrano sugerowany nakład z systemu Prinect.',
            fetchPrinectAmountError: 'Pobranie nakładu z prinecta nie powiodło się.',
            fetchPrinectMakeReadyAmountError: 'Pobranie sugerowanego nakładu z prinecta nie powiodło się.',
            packagingFetchOrdersError: 'Pobranie zamówień nie powiodło się.',
            packagingFetchOrderError: 'Wyszukanie zamówienia nie powiodło się.',
            packagingFetchCouriersError: 'Pobranie przewoźników nie powiodło się.',
            packagingUpdateAddressError: 'Edycja adresu nie powiodła się.',
            packagingFetchBoxesInfoError: 'Pobranie informacji o kartonach nie powiodło się.',
            packagingRecalculateUnitBoxError: 'Edycja kartonów nie powiodła się.',
            packagingPrintLabelsError: 'Wygenerowanie etykiet nie powiodło się.',
            packagingFetchSendingContainerError: 'Nie udało się pobrać stanu nadawania dla adresu.',
            packagingFinishSendingError: 'Zakończenie nadawania nie powiodło się.',
            packagingCreateManualShipmentError: 'Ręczne nadanie przesyłki nie powiodło się.',
            packagingReprintLabelsError: 'Ponowny wydruk etykiet nie powiódł się.',
            packagingPrintLieferscheinError: 'Wydruk Lieferschein nie powiódł się.'
        },
        createPrint: {
            parameters: {
                title: 'Parametry',
                plate: 'Montaż',
                taskNumber: 'Nr zlecenia:'
            },
            mode: {
                title: 'Tryb druku',
                label: 'TRYB DRUKU: {mode}',
                values: {
                    single: 'Jednostronny',
                    double: 'Dwustronny',
                    doubleSw: 'Dwustronny SW'
                },
                emergency: 'TRYB AWARYJNY'
            },
            sides: {
                reportSide: 'Raportowanie strony {side}'
            },
            nextScheduledTasks: {
                title: 'Kolejne zadania'
            }
        }
    },
    machinePlateItems: {
        title: 'Wykonanie płyt dodatkowych',
        action: 'Wykonanie płyt dodatkowych',
        table: {
            noData: 'Brak płyt dodatkowych',
            headers: {
                jobAndPlateNumber: 'Numer zlecenia / montaż',
                colour: 'Kolor',
                side: 'Strona',
                checked: 'Wykonana',
                checkedBy: 'Wykonana przez',
                checkedDate: 'Data wykonania',
                reasons: 'Przyczyna',
                createdBy: 'Osoba zgłaszająca',
                createdAt: 'Data zamówienia'
            }
        }
    },
    prioritization: {
        routeTitle: 'Czas pracy / Priorytetyzacja',
        menuTitle: 'Priorytety',
        pageTitle: 'Priorytetyzacja na stanowiskach produkcyjnych',
        table: {
            noData: 'Brak stanowisk.',
            loadingText: 'Pobieranie stanowisk...',
            headers: {
                siteName: 'Nazwa stanowiska',
                siteType: 'Typ stanowiska',
                actions: 'Akcje'
            },
            changePriority: 'Zmień priorytet'
        },
        changePriorityDialog: {
            title: 'Zmień priorytet zadań',
            table: {
                noData: 'Brak zadań',
                headers: {
                    taskNumber: 'Nr zamówienia',
                    plate: 'Montaż',
                    closedFormat: 'Format',
                    quantity: 'Nakład',
                    date: 'Zaplanowany start',
                    procTaskDuration: 'Zaplanowany czas',
                    status: 'Status',
                    changePriority: 'Zmień priorytet'
                }
            },
            cancel: 'Anuluj',
            save: 'Zapisz'
        },
        notifications: {
            prioritiesSaved: 'Priorytety zostały zapisane.'
        },
        service: {
            fetchProductionSitesError: 'Pobranie stanowisk do priorytetyzacji nie powiodło się.',
            fetchScheduledTasksError: 'Pobranie zaplanowanych zadań nie powiodło się.',
            updatePriorityError: 'Aktualizacja priorytetów nie powiodła się.'
        }
    }
}

export default {
    messages
}
